import { render, staticRenderFns } from "./CourseQuestion.vue?vue&type=template&id=7024bb3b&scoped=true&"
import script from "./CourseQuestion.vue?vue&type=script&lang=js&"
export * from "./CourseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024bb3b",
  null
  
)

export default component.exports